import {
    DeliveryPaymentMappingFragment,
    PaymentType,
    PhoneOrderCreateInput,
    PhoneOrderDraftCreateInput,
    PosOrderCreateInput,
    PosOrderDraftCreateInput,
} from '@/features/graphql/generated/graphql'
import { DeliveryTypeCategory } from '@/features/orders/constants/app'
import {
    PhoneFormInput,
    PhoneFormOutput,
    PosFormInput,
} from '@/features/pos/components/OrderFinalization/form/types'
import { DeliveryPaymentMapping } from '@/features/pos/components/OrderFinalization/types'
import {
    convertDeliveryTypeCategoryToApi,
    convertDeliveryTypeCategoryToApp,
    convertPaymentTypeToApi,
    convertPaymentTypeToApp,
} from '@/features/pos/components/OrderFinalization/utils/conversions'

const transformFormDeliveryAddress = (form: PhoneFormInput | PhoneFormOutput) => {
    if (form.deliveryTypeCategory !== DeliveryTypeCategory.Delivery) return undefined

    const address = form.customer?.address

    if (!address) return undefined

    return {
        coordinates: address.coordinates,
        formattedAddress: address.address,
    }
}

export const transformDeliveryPaymentMapping = (
    deliveryPaymentMapping: DeliveryPaymentMappingFragment
): DeliveryPaymentMapping => ({
    deliveryTypeCategory: convertDeliveryTypeCategoryToApp(
        deliveryPaymentMapping.deliveryTypeCategory
    ),
    paymentTypes: deliveryPaymentMapping.paymentTypes.map(convertPaymentTypeToApp),
})

export const transformFormToPosOrderDraftCreateInput = (
    form: PosFormInput,
    paymentType: PaymentType,
    shouldAttachAutomaticContainers: boolean
): PosOrderDraftCreateInput => ({
    automaticContainerRemovals: shouldAttachAutomaticContainers
        ? form.automaticContainerRemovals
        : [],
    cartNote: form.note,
    deliveryTypeCategory: convertDeliveryTypeCategoryToApi(form.deliveryTypeCategory),
    paymentType: convertPaymentTypeToApi(paymentType),
})

export const transformFormToPhoneOrderDraftCreateInput = (
    form: PhoneFormInput,
    paymentType: PaymentType,
    shouldAttachAutomaticContainers: boolean
): PhoneOrderDraftCreateInput => ({
    automaticContainerRemovals: shouldAttachAutomaticContainers
        ? form.automaticContainerRemovals
        : [],
    cartNote: form.note,
    deliveryTypeCategory: convertDeliveryTypeCategoryToApi(form.deliveryTypeCategory),
    paymentType: convertPaymentTypeToApi(paymentType),
    phoneNumber: form.customer?.phone,
    customerName: form.customer?.name,
    deliveryAddress: transformFormDeliveryAddress(form),
    deliveryTime: form.deliveryTime,
})

export const transformFormToPosOrderCreateInput = (
    form: PosFormInput,
    paymentType: PaymentType,
    shouldAttachAutomaticContainers: boolean
): PosOrderCreateInput => ({
    automaticContainerRemovals: shouldAttachAutomaticContainers
        ? form.automaticContainerRemovals
        : [],
    cartNote: form.note,
    deliveryTypeCategory: convertDeliveryTypeCategoryToApi(form.deliveryTypeCategory),
    paymentType: convertPaymentTypeToApi(paymentType),
})

export const transformFormToPhoneOrderCreateInput = (
    form: PhoneFormOutput,
    paymentType: PaymentType,
    shouldAttachAutomaticContainers: boolean
): PhoneOrderCreateInput => ({
    automaticContainerRemovals: shouldAttachAutomaticContainers
        ? form.automaticContainerRemovals
        : [],
    cartNote: form.note,
    deliveryTypeCategory: convertDeliveryTypeCategoryToApi(form.deliveryTypeCategory),
    paymentType: convertPaymentTypeToApi(paymentType),
    phoneNumber: form.customer?.phone,
    customerName: form.customer?.name,
    deliveryAddress: transformFormDeliveryAddress(form),
    deliveryTime: form.deliveryTime,
})
